export enum Ownership {
  PRIVATE = 'private',
  WORK = 'work',
  WORK_PROFILE = 'work-profile',
}
